"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.sort");
var _customPage = require("@/api/customPage");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      options: [{
        label: '启用',
        value: 1
      }, {
        label: '停用 ',
        value: 0
      }],
      categoryId: '',
      moduleId: '',
      dialogVisible: false,
      ruleForm: {
        categoryName: '',
        sort: '',
        status: ''
      },
      rules: {
        categoryName: [{
          required: false
        }],
        status: [{
          required: false
        }],
        sort: [{
          required: false
        }]
      }
    };
  },
  methods: {
    open: function open(data) {
      //   console.log(data)
      this.moduleId = data.moduleId;
      if (data.type !== 'add') {
        this.categoryId = data.categoryId;
        this.ruleForm.categoryName = data.categoryName;
        this.ruleForm.sort = data.sort;
        this.ruleForm.status = data.status;
      } else {
        this.categoryId = '';
      }
      this.dialogVisible = true;
    },
    onClose: function onClose() {
      this.ruleForm = {
        categoryName: '',
        sort: '',
        status: ''
      };
      this.$refs['ruleForm'].resetFields();
      this.dialogVisible = false;
    },
    submitForm: function submitForm(formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          (0, _customPage.saveOrUpdateCategory)({
            moduleId: _this.moduleId,
            categoryId: _this.categoryId,
            categoryName: _this.ruleForm.categoryName,
            status: _this.ruleForm.status,
            sort: _this.ruleForm.sort
          }).then(function (res) {
            if (res.data) {
              _this.$notify.success({
                title: '温馨提示',
                message: '操作成功'
              });
              _this.$emit('refresh');
              _this.onClose();
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};